import classnames from 'classnames';

import { CmsResource, CmsResourceBgColor } from '@interfaces/common';

import styles from './Resource.module.css';

type ResourceProps = Omit<CmsResource, '_key'>;

const getBgColorValue = (bgColor: CmsResourceBgColor) => {
	switch (bgColor) {
		case 'blue':
			return 'var(--color-future-blue)';
		case 'yellow':
			return 'var(--color-future-yellow)';
		default:
			return 'var(--color-future-green)';
	}
};

export const Resource: React.VFC<ResourceProps> = ({
	image,
	bgColor,
	title,
	subtitle,
	paragraph,
}) => {
	const customProperties = {
		'--comparison-resource-bg-color': getBgColorValue(bgColor),
	} as React.CSSProperties;

	return (
		<article
			className={classnames(styles.wrapper, 'stack-block')}
			style={customProperties}
		>
			<div className={styles['image-wrapper']}>
				<img
					alt=""
					className={styles.image}
					loading="lazy"
					src={`/svgs/${image}.svg`}
				/>
			</div>
			<h2 className={classnames(styles.heading, 'stack-block')}>
				<span className="fluid-font-t2">{title}</span>
				<span className={classnames(styles.subtitle, 'fluid-font-t4-bold')}>
					{subtitle}
				</span>
			</h2>
			{paragraph ? (
				<p className={classnames(styles.paragraph, 'fluid-font-t5')}>
					{paragraph}
				</p>
			) : null}
		</article>
	);
};
